var _defs, _circle, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoRoles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "no_roles_svg__a",
    x: 32.855,
    y: 24.968,
    width: 137.488,
    height: 162.598,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.015
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.015,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2039d1",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no_roles_svg__b",
    x: 33.001,
    y: 35.105,
    width: 123,
    height: 150,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2039d1",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no_roles_svg__c",
    x: 141,
    y: 4,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0d2976",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 253",
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#ffd8a2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6452"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.002)",
    filter: "url(#no_roles_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2400",
    width: 93.228,
    height: 120.294,
    rx: 6.015,
    transform: "rotate(4 -500.12 867.565)",
    fill: "#c8d5ff"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6451",
    transform: "translate(-379.759 -503.615)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.76 503.61)",
    filter: "url(#no_roles_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1893",
    width: 93,
    height: 120,
    rx: 6,
    transform: "translate(48 40.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1895",
    width: 69,
    height: 5,
    rx: 2,
    transform: "translate(438.759 575.713)",
    fill: "#0d2976",
    opacity: 0.102
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5081",
    transform: "translate(438.759 633.713)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 142",
    width: 42,
    height: 19,
    rx: 3,
    transform: "translate(0 -.001)",
    fill: "#6ef29c"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(10 11.999)",
    fill: "#0d2976",
    fontSize: 7,
    fontFamily: "Mulish-Bold, Mulish",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Create"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5267",
    transform: "translate(438.759 587.713)",
    fill: "#0d2976"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1936",
    width: 70,
    height: 4,
    rx: 2,
    transform: "translate(0 -.001)",
    opacity: 0.102
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1937",
    width: 70,
    height: 4,
    rx: 2,
    transform: "translate(0 5.999)",
    opacity: 0.102
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1938",
    width: 60,
    height: 4,
    rx: 2,
    transform: "translate(0 11.999)",
    opacity: 0.102
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(438.759 562.713)",
    fill: "#0d2976",
    fontSize: 7,
    fontFamily: "Mulish-Bold, Mulish",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Role")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5268",
    transform: "translate(438.759 610.713)",
    fill: "#0d2976"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1936",
    width: 70,
    height: 4,
    rx: 2,
    transform: "translate(0 -.001)",
    opacity: 0.102
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1938",
    width: 60,
    height: 4,
    rx: 2,
    transform: "translate(0 5.999)",
    opacity: 0.102
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6627"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#no_roles_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2282",
    width: 40,
    height: 40,
    rx: 20,
    transform: "translate(150 10)",
    fill: "#ff7181"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172.606 30.5l3.909-3.909a1.229 1.229 0 000-1.737l-.869-.869a1.229 1.229 0 00-1.737 0L170 27.894l-3.909-3.909a1.229 1.229 0 00-1.737 0l-.869.869a1.229 1.229 0 000 1.737l3.909 3.909-3.909 3.909a1.229 1.229 0 000 1.737l.869.869a1.229 1.229 0 001.737 0L170 33.106l3.909 3.909a1.229 1.229 0 001.737 0l.869-.869a1.229 1.229 0 000-1.737z",
    fill: "#fff"
  }))));
}
export default SvgNoRoles;